import { CKButton, CKCheckboxNext, CKTextFieldNext } from 'clearkit';
import { FC, useState } from 'react';

type FormTeamProfileProps = {
  value: AccountUpdateDetailsInput;
  onChange: (newValue: AccountUpdateDetailsInput) => void;
};

import { ButtonContainer } from '~/components/unified/ButtonContainer';
import { SettingsCard } from '~/components/unified/SettingsCard';
import { AccountUpdateDetailsInput } from '~/generated/graphql';
import { useEntitlements } from '~/hooks/account';

export const FormTeamProfile: FC<FormTeamProfileProps> = ({
  onChange,
  value,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [teamData, setTeamData] = useState(value);

  const { isOwner, hasAccessSettingsTeamCreation } = useEntitlements();

  const handleSubmit = async () => {
    setIsLoading(true);

    await onChange(teamData);

    setIsLoading(false);
    setIsDirty(false);
  };

  const setFieldValue = (field: string, value: any) => {
    setTeamData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
    setIsDirty(true);
  };

  return (
    <SettingsCard>
      <SettingsCard.Header>
        <SettingsCard.Heading>Team Settings</SettingsCard.Heading>
      </SettingsCard.Header>
      <SettingsCard.Body className="grid gap-6">
        <CKTextFieldNext
          id="name"
          onChange={(value) => setFieldValue('name', value)}
          placeholder="Enter your team name"
          value={teamData.name!}
        >
          <CKTextFieldNext.Label>Team Name</CKTextFieldNext.Label>
        </CKTextFieldNext>
        {hasAccessSettingsTeamCreation ? (
          <div className="pt-6 border-t border-gray-200">
            <CKCheckboxNext
              checked={!!teamData.mfaEnforced}
              id="mfa_enforced"
              isDisabled={!isOwner}
              onChange={(checked) => setFieldValue('mfaEnforced', checked)}
            >
              Enforce Multi-Factor Authentication (MFA)
            </CKCheckboxNext>
          </div>
        ) : null}
      </SettingsCard.Body>
      <SettingsCard.Footer>
        <ButtonContainer>
          <CKButton
            isDisabled={!isDirty}
            isLoading={isLoading}
            onClick={() => setTeamData(value)}
            variant="simple"
          >
            Discard changes
          </CKButton>
          <CKButton
            isDisabled={!isDirty}
            isLoading={isLoading}
            onClick={handleSubmit}
            variant="bold"
            variantColor="blue"
          >
            Save changes
          </CKButton>
        </ButtonContainer>
      </SettingsCard.Footer>
    </SettingsCard>
  );
};
